export default "__VITE_ASSET__DxM7v_Ut__"